<template>
  <!--列表功能模板-->
    <el-row :gutter="4" class="h100">
        <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']"
                v-loading="showList && treeLoading">
            <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                 @click="showList = !showList"></div>
            <el-menu class="h100 metadataTree" :default-active="setGong" @select="selectMenu">
                <el-menu-item :index="item.basicDataId" v-for="item in basicDataList" :key="item.basicDataId">
                    <span slot="title">{{ item.basicDataName }}</span>
                </el-menu-item>
            </el-menu>
        </el-col>
        <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
            <div class="el-table-container">
                <set-workbenches v-if="setGong == 1"></set-workbenches>
                <set-info v-else></set-info>
            </div>
        </el-col>
    </el-row>
</template>

<script>

import SetWorkbenches from "@/views/modules/sys/set/setWorkbenches.vue";
import SetInfo from "@/views/modules/sys/set/setInfo.vue";

export default {
    components: {SetInfo, SetWorkbenches},
    data() {
        return {
            treeLoading: false,
            showList: true,
            basicDataList: [],
            setGong: '',
        }
    },
    mounted() {
        this.getField()
    },
    methods: {
        // 获取字段
        getField() {
            this.basicDataList = [
                {
                    basicDataName: '工作台设置',
                    basicDataId: '1',
                },
                {
                    basicDataName: '消息设置',
                    basicDataId: '2',
                },
            ]
            this.selectMenu(this.basicDataList[0].basicDataId)
        },

        // 选择树节点
        selectMenu(val) {
            this.setGong = val
        },
    },
}
</script>

<style scoped lang="scss">
.metadataTree {
  background: #ffffff;
}

.el-menu {
  border-right: none !important;
}

.el-menu-item, .el-submenu__title {
  height: 34px !important;
  line-height: 34px !important;
  font-size: 14px;
}

.dynamicForm {
  max-height: 74px;
  overflow-y: auto;

  .el-form-item {
    display: inline-block;
    width: 49% !important;
  }
}

.tips {
  padding: 4px;

  .el-icon-info {
    margin-right: 6px;
  }
}
</style>
